// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6572093d","455":"1022c2d5","977":"db7fb517"}[chunkId] + ".chunk.js";
};